module.exports = __webpack_public_path__ + "img/u1300.d8df1628.png";